import { IReturnableActivity } from "types/working-model";
import { GetJson } from "./helpers";

interface Options {
	cursor?: string;
	published?: boolean;
	pageSize?: number;
	offset?: number;
}
export const LoadActivityLog = (channel: number, eventUuid: string, opts?: Options) => {
	const params = new URLSearchParams();
	if (opts?.cursor) {
		params.set('before', opts?.cursor);
	}
	if (opts?.published) {
		params.set('published', 'true');
	}
	if (opts?.pageSize) {
		params.set('pageSize', String(opts.pageSize));
	}
	if (opts?.offset) {
		params.set('offset', String(opts.offset));
	}
	return GetJson<{ next: string | undefined, activities: IReturnableActivity[] }>({
		path: `/v4/admin/activity-log/${channel}/${eventUuid}?${params.toString()}`,
		token: ''
	});
};
